import { render, staticRenderFns } from "./tableTab.vue?vue&type=template&id=373bf261&scoped=true&"
import script from "./tableTab.vue?vue&type=script&lang=js&"
export * from "./tableTab.vue?vue&type=script&lang=js&"
import style0 from "./tableTab.vue?vue&type=style&index=0&id=373bf261&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373bf261",
  null
  
)

export default component.exports